// TODO: Blur-647 This assets types are only for Marine but would be a very good idea use it for every single vertical
// eslint-disable-next-line max-classes-per-file
export interface BaseAsset {
    condition: string
    year?: number
    make?: string
    model?: string
}

export interface Asset {
    condition: string
    year?: number
    make?: string
    model?: string
    trim?: string
    color?: string
    invoice_price?: number
    booking_source?: string
    mileage?: number
    wholesale_price?: number
    like_invoice_price?: number
    boat_type?: string
    hours?: number
    length_ft?: number
    horsepower?: number
    engine_type?: string
    name?: string
    description?: string
    sales_price?: number
}

export interface Collateral {
    asset: Asset
    asset_type: string
    asset_value: number
    data_source: string
    asset_subtype?: string
}

export interface MakeTitleInformation {
    has_title: boolean
    no_title_reason?: string
    no_title_other_reason?: string
}

export interface RvAsset extends BaseAsset {
    rv: number
    rv_type: string
    manufacturer_price: string
    wholesale_price: string
    retail_price: string
    mileage?: number
    oem?: string
    name: string
    title_information?: MakeTitleInformation
}

type nullableString = string | null

export interface CollateralRv<E extends BaseAsset> {
    asset: E
    asset_type: string
    asset_subtype?: string
    asset_name: string
    asset_value: nullableString
    data_source: string
    unique_external_id?: string
    application: number
    is_auto_generated: boolean
}

export interface PostCollateralsAssetsDTO {
    collateral:
        | Collateral[]
        | CollateralRv<RvAsset>[]
        | CollateralMarine<AssetSubType>[]
}

export class ApplicationSubmissionTimeoutError extends Error {}

export class ApplicationSubmissionError extends Error {}

export interface DecisionResult {
    applicationStatus: string
    asyncSubmission: boolean
}
